import React from "react";
import PropTypes from "prop-types";
import "./style.css";

/**
 * @name CheckBox
 * @function
 * @description Displays a Global CheckBox
 * @returns {JSX}
 * @param {*} props
 */
const Checkbox = (props) => {
  /**
   * @name handleselectedFunction
   * @function
   * @description handles the Selected State of Checkbox
   */
  const handleselectedFunction = () =>{
    props.onClick();
  }
  return (
    <div className="checkbox-global">
      <input
        type="checkbox"
        className="checkbox-border checkbox-global__input"
        onChange={handleselectedFunction}
        checked={props.checked}
        aria-label={ props.hasAriaLabel ? props.ariaLabelValue : null }
      />
      {props.value}
    </div>
  );
};

Checkbox.propTypes = {
  onClick: PropTypes.func,
  value: PropTypes.string,
};

export default Checkbox;
